<script>
import ModelIndex from "../models/index"

export default {
  extends: ModelIndex,
  page: {
    title: "JALA Ponds",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('jala_ponds.plural')) }},
    resourceRoute: {default: 'jala_ponds'},
    modelVariable: {default: 'jala_pond'}
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('jala_ponds.plural')),
      items: [
        {
          text: this.lodash.upperFirst(this.$t('jala_ponds.plural')),
          href: "/jala_ponds",
          active: true,
        },
      ],
      filterColumns: {
        name: { type: String, label: this.lodash.upperFirst(this.$t('jala_ponds.name')) },
      },
      sortBy: 'farm.name'
    }
  },
  computed: {
    columns() {
      return {
        ['jala_pond']: [
          { key: 'index', label: '#', sortable: false, style: { width: '1%' } },
          {
            key: 'farm.name',
            label: this.lodash.upperFirst(this.$t('jala_ponds.farm')),
            thStyle: { minWidth: '200px' },
            sortable: true,
            component: {
              props: ['item'],
              template: '<router-link :to="`/farms/${(item.farm || {}).id}`">{{ lodash.get(item, "farm.name") }}</router-link>'
            }
          },
          {
            key: 'name',
            label: this.lodash.upperFirst(this.$t('jala_ponds.name')),
            thStyle: { minWidth: '200px' },
            sortable: true,
            component: {
              props: ['item'],
              template: '<div style="width: 200px" class="text-truncate" :title="item.name">{{ item.name }}</div>'
            }
          },
          { key: 'action', class: 'text-center', style: { width: '1%' } }
        ],
      };
    },
  },
  methods: {
    delete(value) {
      return this.$axios.delete(`/jala/ponds/${this.getModelKey(value)}`)
    },
    fetchModels(page = 1) {
      return this.$axios.get('/jala/ponds', {
        params: {
          page: page,
          per_page: this.perPage,
          search: this.search,
          sort: `${this.sortBy},${this.sortDesc ? 'desc' : 'asc'}`,
          with: 'farm',
          ...this.filterParams
        }
      }).then((response) => {
        const { data: { data, meta } } = response;
        this.models = data.map((datum) => ({
          ...datum,
          _denyShow: false,
          _denyEdit: false,
          _denyDelete: false
        }))
        this.page = Number(meta.current_page);
        this.perPage = Number(meta.per_page);
        this.from = Number(meta.from);
        this.total = Number(meta.total);

        return response;
      }).catch((error) => this.failedAlert(error));
    }
  },
};
</script>
